import { render, staticRenderFns } from "./IconGavel.vue?vue&type=template&id=058d7d88&"
import script from "./IconGavel.vue?vue&type=script&lang=js&"
export * from "./IconGavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports